export default "/images/circle_not_closed.svg?58e61e95692f32d995c53408d0ee2790";